import { queryClient } from "@bodhistreams/queries";
import {
	BodhiChatFloating,
	darkTheme,
	LoginModal,
	RegisterModal,
	ResetModal,
} from "@bodhistreams/ui";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import About from "./pages/About";
import BrandBook from "./pages/BrandBook";
import CertificatePage from "./pages/Certificate";
import Contact from "./pages/Contact";
import DeleteAccount from "./pages/delete-account";
import ConfirmDeletion from "./pages/delete-account/ConfirmDeletion";
import Homepage from "./pages/Homepage";
import Pricing from "./pages/Pricing";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Profile from "./pages/Profile";
import SubscriptionCancel from "./pages/SubscriptionCancel";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import Terms from "./pages/terms";

const AppContent = () => {
	return (
		<Router>
			<ConfigProvider
				theme={darkTheme}
				message={{
					top: 100,
					maxCount: 3,
				}}
			>
				<Routes>
					<Route path="/" element={<Homepage />} />
					<Route path="/pricing" element={<Pricing />} />
					<Route path="/about" element={<About />} />
					<Route path="/brandbook" element={<BrandBook />} />
					<Route path="/certificate" element={<CertificatePage />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/profile" element={<Profile />} />
					<Route
						path="/subscription/success"
						element={<SubscriptionSuccess />}
					/>
					<Route path="/subscription/cancel" element={<SubscriptionCancel />} />
					<Route path="/privacy" element={<PrivacyPolicy />} />
					<Route path="/delete-account" element={<DeleteAccount />} />
					<Route
						path="/delete-account/confirm/:token"
						element={<ConfirmDeletion />}
					/>
					<Route path="/terms" element={<Terms />} />
				</Routes>
				<LoginModal />
				<RegisterModal />
				<ResetModal />
				<BodhiChatFloating />
			</ConfigProvider>
		</Router>
	);
};

const App = () => {
	return (
		<QueryClientProvider client={queryClient}>
			<GoogleOAuthProvider clientId="788011854098-u73tak52ass5ked9lrr0vj9pq5p20od3.apps.googleusercontent.com">
				<AppContent />
			</GoogleOAuthProvider>
		</QueryClientProvider>
	);
};

export default App;
